import React from 'react';
import './styles/styles.scss';

function AppSpinner() {
  return (
    <div className="app-spinner"></div>
  );
}

export default AppSpinner;
